import { Outlet, createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/_app/power-dialer')({
  component: Outlet,
});
